import { useEffect, useRef, useState } from "react";
import type { InstantPayoutStatus } from "../types/payments";
import type { User } from "../types/User";
import { hasSeenInstantIntro, markInstantIntroSeen, shouldShowInstantIntro } from "../utils/instantIntro";

// The Balance tab's one-time "Instant payouts are here" sheet (utils/instantIntro
// holds the rule). `status` / `profile` must be this visit's server answers,
// null until they land. `busy` = another sheet or popup is up: wait for it to
// close rather than stacking on top. Returns [open, close].
export function useInstantIntro(
  accountId: string | null | undefined,
  status: InstantPayoutStatus | null,
  profile: Partial<User> | null,
  busy: boolean
): [boolean, () => void] {
  const [open, setOpen] = useState(false);
  const shown = useRef(false); // once per visit, even where storage can't remember

  useEffect(() => {
    if (shown.current || busy || !accountId) return;
    if (!shouldShowInstantIntro({ status, profile, seen: hasSeenInstantIntro(accountId) })) return;
    shown.current = true;
    markInstantIntroSeen(accountId); // seen the moment it shows: once means once
    setOpen(true);
  }, [accountId, status, profile, busy]);

  return [open, () => setOpen(false)];
}
